import { Link } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

function CallToAction() {
  return (
    <MKBox
      component="section"
      py={8}
      sx={{
        background: "linear-gradient(135deg, #006747 0%, #004d35 100%)",
        borderRadius: "xl",
        mx: { xs: 2, lg: 4 },
        my: 4,
      }}
    >
      <Container>
        <Grid container spacing={3} alignItems="center" justifyContent="center">
          <Grid item xs={12} lg={8} textAlign="center">
            <MKTypography variant="h3" color="white" mb={2}>
              Ready to Give Your Child the Best Start?
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.9} mb={4}>
              Join the Rose of Sharon family today. Our admissions team is ready to guide you 
              through the enrollment process and answer any questions you may have.
            </MKTypography>
            <Grid container spacing={2} justifyContent="center">
              <Grid item>
                <MKButton
                  variant="contained"
                  color="white"
                  size="large"
                  component={Link}
                  to="/admissions"
                  sx={{ color: "#006747" }}
                >
                  Apply Now
                </MKButton>
              </Grid>
              <Grid item>
                <MKButton
                  variant="outlined"
                  color="white"
                  size="large"
                  component={Link}
                  to="/contact"
                >
                  Schedule a Visit
                </MKButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default CallToAction;
